import { SuperAdminModal, SuperAdminModalStyles } from './SuperAdminModal';
import { SuperAdminSupplierAccessManager } from './SuperAdminSupplierAccessManager';

interface SuppliersModalProps {
  visible: boolean;
  onClose: () => void;
  styles?: SuperAdminModalStyles;
}

export const SuppliersModal = ({ visible, onClose, styles }: SuppliersModalProps) => (
  <SuperAdminModal visible={visible} title={'Suppliers'} onClose={onClose} styles={styles}>
    <SuperAdminSupplierAccessManager />
  </SuperAdminModal>
);
